import { render, staticRenderFns } from "./modelFileName.vue?vue&type=template&id=657d3e04&scoped=true"
import script from "./modelFileName.vue?vue&type=script&lang=js"
export * from "./modelFileName.vue?vue&type=script&lang=js"
import style0 from "./modelFileName.vue?vue&type=style&index=0&id=657d3e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657d3e04",
  null
  
)

export default component.exports